import { useGetAtpClusters } from '@ori/global-api-client-react';
import { useMemo } from 'react';
/**
 * Wrapper hook for retrieving ATP Cluster ID for authenticated and anonymous customers.
 * Provides loading and errors states.
 * Can be enabled from the outside to prevent fetching data.
 */
export const useGetAtpClusterId = ({
  customerId,
  enabled = true
}) => {
  const {
    data,
    error
  } = useGetAtpClusters({
    customerId
  }, undefined, {
    swr: {
      enabled,
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  });
  return useMemo(() => ({
    atpClusterId: data?.collection[0]?.atpClusterId,
    error,
    loading: enabled && data === undefined && error === undefined
  }), [data, error, enabled]);
};
//# sourceMappingURL=useGetAtpClusterId.js.map